import { render, staticRenderFns } from "./product-status.vue?vue&type=template&id=9faccd08&scoped=true&"
import script from "./product-status.vue?vue&type=script&lang=js&"
export * from "./product-status.vue?vue&type=script&lang=js&"
import style0 from "./product-status.vue?vue&type=style&index=0&id=9faccd08&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9faccd08",
  null
  
)

export default component.exports